import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TextHidingModule} from '../../directives/text-hiding';
import {L10nModule} from '../translate';
import {LayoutPresetFilterPipe} from './layout-preset-filter.pipe';
import {LayoutPresetSelectorComponent} from './layout-preset-selector.component';
import {LayoutPresetsService} from './layout-presets.service';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        TextHidingModule
    ],
    declarations: [
        LayoutPresetFilterPipe,
        LayoutPresetSelectorComponent
    ],
    exports: [
        LayoutPresetSelectorComponent
    ],
    providers: [
        LayoutPresetsService
    ]
})
export class LayoutPresetSelectorModule {}
